import { decodeHTML } from 'entities'

export const decodeHtmlEntities = str => decodeHTML(str)
